import axios from "axios";

import config from "../config/env";
import { IDept } from "../redux/interfaces";

export const getDepartments = () =>
  axios.get<IDept[]>(`${config.API}/departments`);
